var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunrise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360.04 298.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1",
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M334.41,83.6c-71.47-.34-135.61,41.44-204.59,60.17-42.13,11.44-86.6,14.21-129.82,8.1v146.59h360.04l-25.63-214.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M62.85,67.14l-4.55,9.89c-3.54,7.69,1.59,16.56,10.01,17.35l10.84,1.01,2.87,10.5c2.23,8.16,11.86,11.67,18.82,6.85l8.95-6.2,8.95,6.2c6.96,4.82,16.59,1.31,18.82-6.85l2.87-10.5,10.84-1.01c8.43-.78,13.55-9.66,10.01-17.35l-4.55-9.89,7.66-7.74c5.95-6.02,4.17-16.11-3.48-19.73l-9.84-4.65.89-10.85c.69-8.43-7.16-15.02-15.34-12.87l-10.53,2.76-6.29-8.88c-4.89-6.91-15.14-6.91-20.03,0l-6.29,8.88-10.53-2.76c-8.19-2.15-16.04,4.44-15.34,12.87l.89,10.85-9.84,4.65c-7.65,3.62-9.43,13.71-3.48,19.73l7.66,7.74Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunrise);
export default __webpack_public_path__ + "static/media/sunrise.22f29112783a14bfdbd8b31130100960.svg";
export { ForwardRef as ReactComponent };